export const PageTextNotRenewPayment = `Não identificamos seu primeiro pagamento. Para que você 
receba o acesso a plataforma da Kuppi, basta efetuar o pagamento. Ao efetuar o
pagamento, você estará concordando com os nossos termos de uso, `;
export const PageTextRenewPayment = `Não identificamos seu último pagamento com vencimento
em $$VALIDITY$$. Para que você 
volte a ter acesso a plataforma da Kuppi, basta efetuar o pagamento. Ao efetuar o
pagamento, você estará concordando com os nossos termos de uso, `;
